import React from "react";
import { useTranslation } from "react-i18next";
import MainLayouts from "../layouts/MainLayouts";
import { useBreakpoint } from "../custom-hooks/useBreakpoint";
import FilterDropdown from "../custom-components/filters/FilterDropdown";
import SimplePageHeader from "../components/SimplePageHeader";
import EducationalMaterialsLeftPanel from "../components/EducationalMaterials/EducationalMaterialsLeftPanel";
import EducationalMaterialsRightPanel from "../components/EducationalMaterials/EducationalMaterialsRightPanel";
import MobileFilterButton from "../components/EducationalMaterials/MobileFilterButton";

export default function EducationalMaterials() {
    const { t } = useTranslation();
    const { isTablet, isMobile } = useBreakpoint();

    return (
        <MainLayouts pageTitle={t("educationalMaterials.pageTitle")}>
            <div className="md:hidden w-full mx-auto mt-10 mb-[50px]">
               {/* <h1 className="font-geologica text-2xl font-medium uppercase text-primary-400 mb-5">
                    {t("educationalMaterials.pageTitle")}
                </h1>
                <FilterDropdown />
                <div className="mt-5 relative">
                    <MobileFilterButton isTablet={false} isMobile={true} />
                </div>
                <div className="mt-10">
                    <EducationalMaterialsRightPanel /> 
                </div>*/}
            </div>

            <div className="hidden md:block lg:hidden mb-[32px]">
                <h1 className="font-geologica text-[36px] font-medium leading-[100%] uppercase text-primary-400 mb-[32px]">
                    {t("educationalMaterials.pageTitle")}
                </h1>

               {/* <div className="flex items-center gap-[24px] mb-[32px]">
                    <span className="text-base text-text-300">{t("educationalMaterials.filters.sortBy")}</span>
                    <FilterDropdown /> 
                </div>

                <div className="flex items-center justify-center mb-[50px] relative">
                    <MobileFilterButton isTablet={true} />
                </div>*/}
            </div>

            <div className="hidden lg:block">
                <SimplePageHeader
                    title={t("educationalMaterials.pageTitle")}
                    rightSlot={
                        <div className="flex items-center gap-[24px]">
                        {/*    <span className="text-base text-text-300">{t("educationalMaterials.filters.sortBy")}</span>
                            <FilterDropdown /> */}
                        </div>
                    }
                />
            </div>

            <div className="hidden lg:block w-full max-w-[1280px] mx-auto mb-[100px]">
                <div className="flex gap-[42px]">
                 {/*    <div className="flex-shrink-0">
                        <EducationalMaterialsLeftPanel />
                    </div>
                    */}
                    <div className="flex-1">
                        <EducationalMaterialsRightPanel />
                    </div>
                </div>
            </div>

            <div className="hidden md:block lg:hidden w-full max-w-[1280px] mx-auto mb-[100px]">
                <EducationalMaterialsRightPanel />
            </div>
        </MainLayouts>
    );
}
